var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oauth-cb"},[_c('van-loading',{attrs:{"color":"#1989fa","vertical":""}},[_vm._v("钉钉登录中...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }